import { useState } from "react";
import supabase from "../supabase";
import { CATEGORIES } from "./categories";


function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}


function FactForm({ setFacts, setShowForm }) {
    let [ factText, setFactText ] = useState("")
    let [ factSource, setFactSource ] = useState("")
    let [ factCategory, setFactCategory ] = useState("")
    let [ isUploading, setIsUploading ] = useState(false)


    async function handleSubmit(e) {
        e.preventDefault()
        console.log(factText, factSource, factCategory)

        if (factText && isValidHttpUrl(factSource) && factCategory && (factText.length < 200)) console.log("valid form data exists")
    
        // To only update the UI and refresh the screen
        // let newFact = {
        //     id: Math.round(Math.random()*1000000),
        //     text: factText,
        //     source: factSource,
        //     category: factCategory,
        //     votesInteresting: 0,
        //     votesMindblowing: 0,
        //     votesFalse: 0,
        //     createdIn: new Date().getFullYear(),
        // }

        // To update Supabase and receive the new fact created into the list
        // let { data: newFact, error } = await supabase.from("facts")
        //         .insert([{factText, factSource, factCategory}])
        //         .select()


        setIsUploading(true);
        const { data: newFact, error } = await supabase
            .from('facts')
            .insert([{ text: factText, source: factSource, category: factCategory },])
            .select()
        setIsUploading(false);

        if (!error) {
            console.log(newFact)
            setFacts((facts)=>[newFact[0], ...facts])
        } else {
            console.log("Error inserting", error)
        }

        setFactText("")
        setFactSource("")
        setFactCategory("")

        setShowForm(false)
    
    }

    return (
        <>
            <form id="fact-form" className="fact-form" action="#" onSubmit={handleSubmit}>
            <div className="fact-form-content">
              <div>
                <label htmlFor="new-fact">Fact</label>
                <input type="text" name="new-fact" id="new-fact" 
                       placeholder="share a fact with the world" value={factText}
                       onChange={(e) => setFactText(e.target.value)}
                       disabled={isUploading}
                >
                </input>
                {/* <span className="input-text"><span>200</span> characters remaining</span> */}
                <span>{200 - factText.length}</span>
                
              </div>
              <div>
                <label htmlFor="source">Source</label>
                <input type="text" name="source" id="source" 
                       placeholder="enter a trustworthy source" value={factSource}
                       onChange={(e) => setFactSource(e.target.value)}
                       disabled={isUploading}
                >
                </input>
                
                <select name="category" id="category" value={factCategory}
                       onChange={(e) => setFactCategory(e.target.value)}
                       disabled={isUploading}
                >
                  <option value="" defaultValue>Choose category</option>
                  <option value="all">All</option>
                  {CATEGORIES.map((category)=><option key={category.name} value={category.name}>{category.name.toUpperCase()}</option>)}
                </select>
              </div>
            </div>
            <button className="btn btn-narrow btn-mixed-colors fact-form-button" 
                    disabled={isUploading}
            >
                Post
            </button>
          </form>
        </>
    );
}
  
export default FactForm;